module.exports = {"name":"tacoHearts","audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":0,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"v1","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/tacoHearts.json
// module id = xWYk
// module chunks = 2